import { ConfigEffects } from './config/config.effect';
import { TerminationEffects } from './termination.effects';
import { WebviewEffect } from './webview.effect';

export const list = [TerminationEffects, ConfigEffects, WebviewEffect];

export * from './termination.effects';
export * from './config/config.effect';
export * from './webview.effect';
